import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import BasicInformation from './components/BasicInformation';


const { Cell } = ResponsiveGrid;

const CommunityInformation = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="社區基本資料"
        // description="住戶建立戶號"
        breadcrumbs={[
          {
            name: '社區管理',
          },
          {
            name: '社區基本資料',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <BasicInformation />
    </Cell>

    
  </ResponsiveGrid>
);

export default CommunityInformation;
